import { combineReducers } from "@reduxjs/toolkit";
import { authSlice } from "./slice/authSlice/authSlice";
import { essentialSlice } from "./slice/essentialSlice/essentialSlice";
import { brandSlice } from "./slice/menuSlice/brandSlice";
import { catagoriesSlice } from "./slice/menuSlice/catagoriesSlice";
import { customerCardSlice } from "./slice/menuSlice/customer/cardSlice";
import { customerCreditSlice } from "./slice/menuSlice/customer/creditSlice";
import { customerAddressSlice } from "./slice/menuSlice/customer/customerAddressSlice";
import { customerSlice } from "./slice/menuSlice/customer/customerSlice";
import { customerDiscountSlice } from "./slice/menuSlice/customer/discountSlice";
import { packingSlice } from "./slice/menuSlice/customer/packingSlice";
import { receivableSlice } from "./slice/menuSlice/customer/receivableSlice";
import { userSlice } from "./slice/menuSlice/customer/userSlice";
import { inventorySlice } from "./slice/menuSlice/inventorySlice";
import { orderSlice } from "./slice/menuSlice/orderSlice";
import { pricingGroupSlice } from "./slice/menuSlice/priceSlice";
import { productSlice } from "./slice/menuSlice/productSlice";
import { purchaseOrderSlice } from "./slice/menuSlice/purchaseOrderSlice";
import { supplierSlice } from "./slice/menuSlice/supplierSlice";
import { tempProductSlice } from "./slice/menuSlice/tempProductSlice";
import { storeSettingsSlice } from "./slice/settingsSlice/storeSettingsSlice";
//import { commonSlice } from "./slice/commonSlice/commonSlice";
import { commonSlice } from "./slice/commonSlice/commonSlice";
import { dashboardSlice } from "./slice/dashboardSlice/dashboardSlice";
import { lumberCalculatorSlice } from "./slice/lumberSlice/lumberSlice";
import { billSlice } from "./slice/menuSlice/billSlice";
import { rebateCustomerSlice } from "./slice/menuSlice/customer/rebateCustomerSlice";
import { employeeSlice } from "./slice/menuSlice/employee";
import { orderproductSlice } from "./slice/menuSlice/orderproduct/orderproductSlice";
import { priceDashBoardSlice } from "./slice/menuSlice/priceDashBoardSlice";
import { pricingWatchSlice } from "./slice/menuSlice/priceWatchSlice";
import { returnOrderSlice } from "./slice/menuSlice/returnOrderSlice";
import { vehicleSlice } from "./slice/menuSlice/vehicleSlice";
import { orderPaymentSlice } from "./slice/paymentSlice/orderPaymentSlice";
import { financialSlice } from "./slice/reportSlice/financialReport";
import { inventoryReportSlice } from "./slice/reportSlice/inventoryReport";
import { packingslipSlice } from "./slice/reportSlice/packingslip";
import { posreportSlice } from "./slice/reportSlice/posReport";
import { credentialSlice } from "./slice/settingsSlice/credentialSlice";
import { estimationQuotationSlice } from "./slice/settingsSlice/estimaQuotaSlice";
import { loomisListSlice } from "./slice/settingsSlice/loomisSlice";
import { monerisSlice } from "./slice/settingsSlice/monerisSlice";
import { rebateDateSlice } from "./slice/settingsSlice/rebateDateSlice";
import { rolesSlice } from "./slice/settingsSlice/roleSlice";
import { seoMetaSlice } from "./slice/settingsSlice/seoMetaSlice";
import { templatesSlice } from "./slice/settingsSlice/templatesSlice";

const reducers = combineReducers({
  auth: authSlice.reducer,
  storeSettings: storeSettingsSlice.reducer,
  supplier: supplierSlice.reducer,
  catagories: catagoriesSlice.reducer,
  brand: brandSlice.reducer,
  bill: billSlice.reducer,
  essential: essentialSlice.reducer,
  product: productSlice.reducer,
  purchaseOrder: purchaseOrderSlice.reducer,
  customer: customerSlice.reducer,
  customerRebate: rebateCustomerSlice.reducer,
  customerMemo: customerDiscountSlice.reducer,
  customerAddress: customerAddressSlice.reducer,
  customerCredit: customerCreditSlice.reducer,
  customerCard: customerCardSlice.reducer,
  customerUser: userSlice.reducer,
  customerReceivable: receivableSlice.reducer,
  customerPacking: packingSlice.reducer,
  tempProduct: tempProductSlice.reducer,
  pricingGroup: pricingGroupSlice.reducer,
  order: orderSlice.reducer,
  inventory: inventorySlice.reducer,
  common: commonSlice.reducer,
  pricingWatch: pricingWatchSlice.reducer,
  priceDashBoard: priceDashBoardSlice.reducer,
  orderPayment: orderPaymentSlice.reducer,
  returnOrder: returnOrderSlice.reducer,
  employee: employeeSlice.reducer,
  packingslip: packingslipSlice.reducer,
  posreport: posreportSlice.reducer,
  inventoryReport: inventoryReportSlice.reducer,
  estimationQuotation: estimationQuotationSlice.reducer,
  lumberCalculator: lumberCalculatorSlice.reducer,
  financial: financialSlice.reducer,
  orderproduct: orderproductSlice.reducer,
  vehicle: vehicleSlice.reducer,
  roles: rolesSlice.reducer,
  dashboard: dashboardSlice.reducer,
  templates: templatesSlice.reducer,
  seoMeta: seoMetaSlice.reducer,
  rebateDate: rebateDateSlice.reducer,
  credential: credentialSlice.reducer,
  loomis: loomisListSlice.reducer,
  moneris: monerisSlice.reducer
});

export default reducers;